export const PROJECTS_DATA = [
  {
    id: "portfolio",
    name: "Personal Portfolio",
    type: "FRONTEND",
    impact: "CUSTOM UI / UI ENGINEERING",
    stack: ["React", "Tailwind", "Framer Motion"],
    description:
      "A highly animated portfolio showcasing advanced UI systems, sound design, and performance-driven React architecture.",
    repo: "kallmenikhil/portfolio",
    live: "https://whynikhil.xyz",
  },

  {
    id: "bharosa",
    name: "bharosa",
    type: "FULL STACK",
    impact: "Anti Counterfeit Supply Chain System",
    stack: ["React", "Node.js", "Express", "PostgreSQL"],
    description:
      "A full-stack anti-counterfeit supply chain system designed to verify product authenticity and improve transparency across the supply chain.",
    repo: "kallmenikhil/bharosa",
    live: "https://bharosa.whynikhil.xyz",
  },

  {
    id: "collab-board",
    name: "Difflane",
    type: "FULL STACK",
    impact: "ollaborative Coding Platform",
    stack: ["React", "Node.js", "Socket.io", "MongoDB"],
    description:
      "A realtime collaborative workspace allowing multiple users to code and see live cursor updates powered by Yjs and WebSockets.",
    repo: "kallmenikhil/difflane",
    live: "https://difflane.whynikhil.xyz",
  },

  {
    id: "satya-vote",
    name: "SatyaVote",
    type: "FULL STACK",
    impact: "CIVIC TECH / VOTING PLATFORM",
    stack: ["React", "Node.js", "Express", "MongoDB", "JWT"],
    description:
      "A secure digital voting platform enabling transparent elections with authentication, admin dashboards, live vote counts, and real-time result visualization.",
    repo: "kallmenikhil/satya-vote",
    live: "https://vote.whynikhil.xyz",
  },

  {
    id: "green-delhi",
    name: "Green Delhi Platform",
    type: "FULL STACK",
    impact: "REAL WORLD PROJECT",
    stack: ["React", "Node.js", "MongoDB"],
    description:
      "A civic-focused platform built to improve urban sustainability initiatives through data-driven dashboards and user participation.",
    repo: "kallmenikhil/vayu-vaex",
    live: "https://climate.whynikhil.xyz",
  }
];
